import FloatingAlert from './FloatingAlert';

export default FloatingAlert;
